import { AsyncOperationsModel } from "../../../utility/AsyncOperationsModel";
import { observable, action, runInAction } from "mobx";
import { IUsersAnalytics } from "../../../utility/admin/UsersControls/UsersAnalytics/IUsersAnalytics";
import BaseComponent from "../../../utility/BaseComponent";
import { withRouter, BrowserHistroy } from "react-router-dom";
import * as React from "react";
import { CircularProgress } from 'react-md';
import "./static/UsersView.scss";
import UsersAnalytics, { UsersAnalyticsModel } from "../UsersAnalytics/UsersAnalytics";
import { isNullOrUndefined } from "util";
import { observer } from "mobx-react";
import UsersTableView, { UsersTableViewModel } from "../UsersTableView/UsersTableView";
import { IServicesProvider } from "../../../di/IServicesProvider";
export class UsersViewModel extends AsyncOperationsModel {
    @observable services: IServicesProvider;
    @observable usersAnalytics: IUsersAnalytics;
    @observable organisationCode: string;
    constructor(services: IServicesProvider, organisationCode?: string) {
        super();
        this.services = services;
        if (!isNullOrUndefined(organisationCode)) {
            this.organisationCode = organisationCode;
        }
    }
    
    @action
    prepare() {
        this.incrementAsyncOperations();
        let controls = this.services.getAdminServicesProvider().getUsersControls();
        controls.getAnalytics()
        .first()
        .subscribe(
            item => {
                if (this.asyncOperationsCount > 0) {
                    this.decrementAsyncOperations();
                }
                runInAction( () => {
                    this.usersAnalytics = item;
                });
            }
        );
    }
}
@observer class UsersView extends BaseComponent< {model: UsersViewModel, history: BrowserHistroy}, {}> {
    private userTableViewModel = new UsersTableViewModel(
        this.props.model.services,
        this.props.model.organisationCode
    );
    render() {
        return (
            <div className="UsersViewContainer GeneralViewContainer">
                <div className="row">
                    <h2>Overview</h2>
                    {
                        isNullOrUndefined(this.props.model.usersAnalytics) &&
                        <CircularProgress centered={true} id="Progress" />
                    }
                    {
                        !isNullOrUndefined(this.props.model.usersAnalytics) &&
                        <UsersAnalytics model={new UsersAnalyticsModel(this.props.model.usersAnalytics)} />
                    }
                </div>
                <div className="row">
                    <h2>Users</h2>
                    <UsersTableView 
                        model={this.userTableViewModel} 
                    />
                </div>
            </div>
        );
    }
}
export default withRouter(UsersView);


// WEBPACK FOOTER //
// ./src/view/Admin/UsersView/UsersView.tsx